const DESKTOP_QUERY = '(min-width: 1024px)'

/**
 * On desktop, the block pins to the viewport for the height of its scroll
 * track (--pl-steps * 100vh) while the user scrolls through it. This maps
 * that scroll progress to a step index and toggles data-active accordingly,
 * so layers switch as the user scrolls instead of only on click.
 */
const setActiveStep = (buttons, contents, index) => {
  buttons.forEach(button => {
    button.dataset.active = String(Number(button.dataset.tabindex) === index)
  })
  contents.forEach(content => {
    content.dataset.active = String(Number(content.dataset.tabindex) === index)
  })
}

const scrollToStep = (track, index, steps) => {
  const total = track.offsetHeight - window.innerHeight
  if (total <= 0) return

  const trackTop = track.getBoundingClientRect().top + window.scrollY
  const target = trackTop + (total * (index + 0.5)) / steps

  window.scrollTo({ top: target, behavior: 'smooth' })
}

/**
 * On mobile, the layer graphic sits above the content column, so switching
 * layers happens off-screen. This scrolls the newly active content into view
 * on narrow viewports, where the two columns are stacked instead of
 * side-by-side (matches the lg breakpoint used in the block's layout).
 */
export const initializeProcessLayers = () => {
  const blocks = document.querySelectorAll('[data-block-type="process-layers"]')

  blocks.forEach(block => {
    const buttons = block.querySelectorAll('[data-component="tab-button"]')
    const contents = block.querySelectorAll('[data-component="tab-content"]')
    const track = block.closest('.process-layers-track')

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        if (window.innerWidth >= 1024) {
          if (track) scrollToStep(track, Number(button.dataset.tabindex), contents.length)
          return
        }

        const content = block.querySelector(
          `[data-component="tab-content"][data-tabindex="${button.dataset.tabindex}"]`
        )

        content?.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    })

    if (!track) return

    const steps = contents.length
    let ticking = false

    const update = () => {
      ticking = false

      if (!window.matchMedia(DESKTOP_QUERY).matches) return

      const rect = track.getBoundingClientRect()
      const total = rect.height - window.innerHeight
      if (total <= 0) return

      const progress = Math.min(Math.max(-rect.top / total, 0), 1)
      const index = Math.min(Math.floor(progress * steps), steps - 1)

      setActiveStep(buttons, contents, index)
    }

    const onScroll = () => {
      if (ticking) return
      ticking = true
      requestAnimationFrame(update)
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    update()
  })
}
